import 'core-js/stable'

import Vue from 'vue'

import '@/plugins/environmentHelper.js'

import '@/utils/customHelper.js'
import '@/utils/persistanceHelper.js'
import '@/utils/signalR.js'

import '@/plugins/captchaConfigurator.js'

import '@/plugins/templateConfigurator.js'

import i18n from '@/plugins/i18n'
import vuetify from '@/plugins/vuetify'

import '@/plugins/veeValidate'
import '@/plugins/moment'
import '@/plugins/axios'
import '@/plugins/hostConfigurator.js'
import '@/plugins/directives/test.js'
import store from '@/store'
import router from '@/router'

import '@/utils/mixins/global'
import App from './App.vue'
import '@/utils/customErrors.js'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  components: { App },
  i18n,
  render: h => h(App)
}).$mount('#app')
